import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PixelShiftIcon } from './icons/PixelShiftIcon';
import WaitlistModal from './WaitlistModal';

// Helper function to track events in Google Analytics
const trackEvent = (eventName: string, eventParams?: Record<string, any>) => {
  if (typeof window !== 'undefined' && (window as any).gtag) {
    (window as any).gtag('event', eventName, eventParams);
  }
};

const Header: React.FC = () => {
  const [isWaitlistOpen, setIsWaitlistOpen] = useState(false);
  
  const handleGoProClick = () => {
    // Track the button click
    trackEvent('go_pro_clicked', {
      location: 'header',
    });
    setIsWaitlistOpen(true);
  };

  return (
    <>
      <header className="w-full bg-gray-900/80 backdrop-blur-sm sticky top-0 z-50 border-b border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center">
              <PixelShiftIcon className="h-8 w-8 text-brand-primary" />
              <span className="ml-3 text-2xl font-bold text-white tracking-tight">
                PixelShift
              </span>
            </Link>
            <div className="flex items-center space-x-6">
               <Link 
                 to="/blog"
                 className="text-gray-300 hover:text-white transition-colors font-medium"
               >
                 Blog
               </Link>
               <button 
                 onClick={handleGoProClick}
                 className="relative inline-flex items-center justify-center px-5 py-2 overflow-hidden font-medium text-indigo-300 transition duration-300 ease-out border-2 border-brand-primary rounded-full shadow-md group"
               >
                  <span className="absolute inset-0 flex items-center justify-center w-full h-full text-white duration-300 -translate-x-full bg-brand-primary group-hover:translate-x-0 ease">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path></svg>
                  </span>
                  <span className="absolute flex items-center justify-center w-full h-full text-white transition-all duration-300 transform group-hover:translate-x-full ease">Go Pro</span>
                  <span className="relative invisible">Go Pro</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      <WaitlistModal 
        isOpen={isWaitlistOpen} 
        onClose={() => setIsWaitlistOpen(false)} 
      />
    </>
  );
};

export default Header;

